import styled from "styled-components";

import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../constants/Styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
`;

export const Description = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size24};
  font-weight: ${FONT_WEIGHT.weight400};
  max-width: 40rem;
  margin: 3rem 0;
  text-align: center;
`;

export const FinePrint = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size12};
  font-weight: ${FONT_WEIGHT.weight200};
  margin-top: 1rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 25rem;

  > span {
    text-align: center;
    font-size: ${FONT_SIZE.size18};
    margin-bottom: 2rem;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  > button {
    width: 100%;
    margin-top: 1rem;
  }
`;

export const MarketingInfo = styled.div`
  color: ${COLORS.secondaryLight};
  margin: 1rem 0;
`;

export const Info = styled.div`
  height: 4rem;
  margin-top: 0.5rem;
  text-align: center;
`;
